import type { marked } from 'marked';

import type { RendererFn } from '../type';

export const space: RendererFn<marked.Tokens.Space> = () => {
  return null;
};
